import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import imageEmpty from "../../images/icons8-image-100.png";
import { useDispatch, useSelector } from "react-redux";
import { getOneProduct } from "../../redux/actions/productsAction";
const UserAllOrderCard = ({ item }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOneProduct(item.product.id));
  }, []);

  const oneProducts = useSelector((state) => state.allproducts.oneProduct);
  return (
    <div>
      <Row className="d-flex mb-2">
        <Col xs="3" md="2" className="d-flex justify-content-start">
          <Link
            to={`/products/${item.product._id}`}
            style={{ textDecoration: "none" }}
          >
            {oneProducts.data ? (
              <img
                width="93px"
                height="120px"
                src={oneProducts.data.image}
                alt=""
              />
            ) : (
              <img width="93px" height="120px" src={imageEmpty} alt="" />
            )}
          </Link>
        </Col>
        <Col xs="8" md="6">
          <div className="d-inline pt-2 cat-title">
            {item.product.title || ""}
          </div>
          <div className="d-inline pt-2 cat-rate me-2">
            {item.product.ratingsAverage ? item.product.ratingsAverage : 0}
          </div>
          <div className="rate-count d-inline p-1 pt-2">
            ({`${item.product.ratingsQuantity || 0} تقييم`})
          </div>
          <div className="mt-3 d-flex">
            <div className="cat-text mt-1  d-inline">الكميه</div>
            <span
              className="mx-2 "
              type="number"
              style={{ width: "40px", height: "30px" }}
            >
              {item.quantity}
            </span>
            {/* <input
              value={item.quantity}
              className="mx-2 "
              type="number"
              style={{ width: "40px", height: "30px" }}
            /> */}
            <div
              className="color  d-inline"
              style={{ backgroundColor: item.color }}
            ></div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UserAllOrderCard;
